"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.columnLetterToNumber = exports.readWorksheet = exports.sanitizeFile = exports.getJsonDataFromBase64 = exports.isFileTooLargeForFlatfileUpload = exports.isImportDeletionBlocked = void 0;
const sanitize_html_1 = __importDefault(require("sanitize-html"));
const xlsx_1 = require("xlsx");
const import_1 = require("../constants/import");
const import_2 = require("../enums/import");
const utils_1 = require("./utils");
const isImportDeletionBlocked = (status, createdAtUtc) => (status === import_2.ImportStatus.Created || status === import_2.ImportStatus.Processing) &&
    Date.now() - new Date(createdAtUtc).getTime() < import_1.IMPORT_PROCESSING_STALE_AFTER_MS;
exports.isImportDeletionBlocked = isImportDeletionBlocked;
const isFileTooLargeForFlatfileUpload = (fileSizeBytes) => fileSizeBytes > import_1.MAX_FLATFILE_UPLOAD_FILE_SIZE_BYTES;
exports.isFileTooLargeForFlatfileUpload = isFileTooLargeForFlatfileUpload;
const getJsonDataFromBase64 = (base64) => {
    try {
        const byteString = atob(base64);
        if (byteString.length > import_1.MAX_IMPORT_FILE_SIZE) {
            return { error: { code: "file_too_big", message: "Please upload a file smaller than 20MB." }, data: [] };
        }
        const sheet0 = getXlsxFromBase64(base64);
        const endCell = sheet0["!ref"]?.split(":")?.[1];
        const endCell2 = sheet0["!ref"]?.split(":")?.[1];
        const rowNum = endCell ? parseInt(endCell.replace(/[A-Za-z]/g, "")) : 0;
        const columnLetter = endCell2 ? endCell2.replace(/[0-9]/g, "") : "";
        const columnNum = (0, exports.columnLetterToNumber)(columnLetter);
        if (columnNum > import_1.MAX_IMPORT_COLUMNS_IN_IMPORT + 1) {
            return {
                error: {
                    code: "too_many_columns",
                    message: "File must have less than " + import_1.MAX_IMPORT_COLUMNS_IN_IMPORT + " columns",
                },
                data: [],
            };
        }
        if (isNaN(rowNum) || !rowNum) {
            return { error: { code: "not_enough_rows", message: "File must have at least one row." }, data: [] };
        }
        if (rowNum > import_1.MAX_COUNT_IN_IMPORT + 1) {
            return {
                error: { code: "too_many_rows", message: "File must have less than " + import_1.MAX_COUNT_IN_IMPORT + " rows" },
                data: [],
            };
        }
        // option raw: false is to get the value of the cell as string without formats (numbers, dates, etc.)
        const jsonData = xlsx_1.utils.sheet_to_json(sheet0, { raw: false });
        const sanitizeResponse = (0, exports.sanitizeFile)(jsonData);
        return { data: cleanJsonData(sanitizeResponse) };
    }
    catch (_error) {
        return { error: { code: "parsing_base_64_failed", message: "Parsing base 64 failed" }, data: [] };
    }
};
exports.getJsonDataFromBase64 = getJsonDataFromBase64;
const getXlsxFromBase64 = (base64) => {
    const buffer = Buffer.from(base64, "base64");
    const workbook = (0, exports.readWorksheet)(buffer);
    return workbook.Sheets[workbook.SheetNames[0]];
};
const sanitizeFile = (jsonData) => {
    const clean = sanitizeHtmlWithoutChars(JSON.stringify(jsonData), {
        allowedTags: [], // No tags allowed
        allowedAttributes: {}, // No attributes allowed
    });
    return JSON.parse(clean);
};
exports.sanitizeFile = sanitizeFile;
const sanitizeHtmlWithoutChars = (value, sanitizeHtmlConfig) => {
    return ((0, sanitize_html_1.default)(value, sanitizeHtmlConfig)
        // https://github.com/apostrophecms/sanitize-html#readme
        // no need to set back the html characters since the authorized tags are not escaped
        .replace(/&amp;/g, "&")
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        // .replace(/&quot;/g, '"')
        // .replace(/&#039;/g, "'")
        // trim all input to avoid any complications with third party apis or other
        .trim());
};
const cleanJsonData = (jsonData) => {
    return jsonData
        .map((row) => {
        const cleanedRow = {};
        Object.keys(row).forEach((key) => {
            if (!key.startsWith("__EMPTY")) {
                cleanedRow[key] = row[key];
            }
        });
        return cleanedRow;
    })
        .filter(utils_1.Utils.notEmpty);
};
const readWorksheet = (buffer) => {
    return (0, xlsx_1.read)(buffer);
};
exports.readWorksheet = readWorksheet;
const columnLetterToNumber = (columnLetter) => {
    let columnNumber = 0;
    for (let i = 0; i < columnLetter.length; i++) {
        columnNumber = columnNumber * 26 + (columnLetter.charCodeAt(i) - "A".charCodeAt(0) + 1);
    }
    return columnNumber;
};
exports.columnLetterToNumber = columnLetterToNumber;
